
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ErrorModel } from '@models/error';

@Component({
    selector: 'customizer-changes',
    templateUrl: 'customizer-changes.html',
    styleUrls: ['./customizer-changes.scss'],
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class CustomizerChangesComponent {

	@Input() changes: Array<ErrorModel>;
	@Output() changesChange = new EventEmitter<boolean>();

	constructor() { }

	public saveChanges(ok: boolean) {
		this.changesChange.emit(ok);
	}

}
